import { inject, Injectable } from '@angular/core';
import { AuthorizedUser } from '@decorators';
import { PlanType, UserState } from 'moddy/common';

@Injectable({
    providedIn: 'root'
})
export class PlanPaymentAvailabilityService {
    private readonly user = inject(UserState).value;
    private readonly sortedPlanTypes: PlanType[] = ['demo', 'basic', 'premium'];

    private get userPlanType(): PlanType {
        return this.user()!.subscriptionData!.planType;
    }

    @AuthorizedUser()
    public canBuy(planType: PlanType): boolean {
        const planIndex = this.sortedPlanTypes.indexOf(planType);
        const userPlanIndex = this.sortedPlanTypes.indexOf(this.userPlanType);

        return userPlanIndex < planIndex;
    }

    @AuthorizedUser()
    public canChangePlan(planType: PlanType): boolean {
        return this.userPlanType !== 'demo' && this.userPlanType !== planType;
    }

    @AuthorizedUser()
    public isUserHaveDifferentPlan(planType: PlanType): boolean {
        return this.userPlanType !== planType;
    }
}
